"use strict";

import { cxAlwaysInTouchConstants } from "../_constants";

export const cxGetWinnersRequest = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_GET_WINNERS_REQUEST,
          payload,
     };
};

export const cxGetWinnersComplete = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_GET_WINNERS_COMPLETE,
          payload,
     };
};

export const cxGetWinnersExportRequest = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_GET_WINNERS_EXPORT_REQUEST,
          payload,
     };
};

export const cxGetWinnersExportComplete = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_GET_WINNERS_EXPORT_COMPLETE,
          payload,
     };
};

export const cxClearWinnersExport = () => {
     return {
          type: cxAlwaysInTouchConstants.CX_CLEAR_WINNERS_EXPORT,
     };
};

export const cxGetWinnerFilterOptionsRequest = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_GET_WINNER_FILTER_OPTIONS_REQUEST,
          payload,
     };
};

export const cxGetWinnerFilterOptionsComplete = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_GET_WINNER_FILTER_OPTIONS_COMPLETE,
          payload,
     };
};

export const cxGetJobRolesRequest = () => {
     return {
          type: cxAlwaysInTouchConstants.CX_GET_JOB_ROLES_REQUEST,
     };
};

export const cxGetJobRolesComplete = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_GET_JOB_ROLES_COMPLETE,
          payload,
     };
};

export const cxAddWinnersRequest = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_ADD_WINNERS_REQUEST,
          payload,
     };
};

export const cxAddWinnersComplete = (payload) => {
     return {
          type: cxAlwaysInTouchConstants.CX_ADD_WINNERS_COMPLETE,
          payload,
     };
};

export const cxClearAddWinnersResult = () => {
     return {
          type: cxAlwaysInTouchConstants.CX_CLEAR_ADD_WINNERS_RESULT,
     };
};
